<script>
import { mapState } from 'pinia';
import { useFeedStore } from '../../../store/useFeedStore.js';

export default {
  name: 'CpSocialFeedSidebarMenu',
  directives: {
    margin: require('../directives/margins').margin,
    marginBottom: require('../directives/margins').marginBottom,
    marginTop: require('../directives/margins').marginTop,
  },
  components: {
    CpInviteMembersDialog: require('../dialogs/invite-members').default,
  },
  props: {
    category: { type: String },
  },
  created() {
    if (
      ['home', 'community', 'news', 'tv', 'petitions', 'members', 'campaigns', 'races', 'blogs', 'representatives', 'polls', 'groups', 'events'].includes(
        this.sidebarCategory,
      )
    ) {
      this.activeDataCategory = this.sidebarCategory;
    }
  },
  data: function () {
    return {
      activeDataCategory: '',
      isOpenMoreOptions: false,
    };
  },
  methods: {
    handleLinkClick(categoryClicked) {
      this.activeDataCategory = categoryClicked;
      this.$emit('sidebarLinkClicked', categoryClicked);
    },
    handleMoreOptions() {
      this.isOpenMoreOptions = !this.isOpenMoreOptions;
    },
  },
  computed: {
    ...mapState(useFeedStore, ['sidebarCategory']),
  },
  watch: {
    sidebarCategory: function (newVal) {
      this.activeDataCategory = newVal;
    },
  },
};
</script>
<template>
  <nav v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet }">
    <a class="sidebar-link" v-on:click="handleLinkClick('home')" v-bind:class="{ active: activeDataCategory == 'home', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-compass icon"></i>
        <span class="buttons sidebar-menu-title">Latest</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('campaigns')" v-bind:class="{ active: activeDataCategory == 'campaigns', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-podium icon"></i>
        <span class="buttons sidebar-menu-title">Campaigns</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('community')" v-bind:class="{ active: activeDataCategory == 'community', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-people-arrows icon"></i>
        <span class="buttons sidebar-menu-title">Community</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('news')" v-bind:class="{ active: activeDataCategory == 'news', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-rss-square icon"></i>
        <span class="buttons sidebar-menu-title">News</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('groups')" v-bind:class="{ active: activeDataCategory == 'groups', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-user-friends icon"></i>
        <span class="buttons sidebar-menu-title">Groups</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('polls')" v-bind:class="{ active: activeDataCategory == 'polls', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-poll icon"></i>
        <span class="buttons sidebar-menu-title">Polls</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleLinkClick('representatives')" v-bind:class="{ active: activeDataCategory == 'representatives', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal fa-landmark icon"></i>
        <span class="buttons sidebar-menu-title">{{$root.isSmallDesktop ? 'Represent...' : 'Representatives'}}</span>
      </div>
    </a>
    <a class="sidebar-link" v-on:click="handleMoreOptions()" v-bind:class="{ active: activeDataCategory == 'more', mobile: $root.isMobile }">
      <div class="social-sidebar-menu-item">
        <i class="fal icon" :class="{ 'fa-plus-circle': !isOpenMoreOptions, 'fa-minus-circle': isOpenMoreOptions }"></i>
        <span class="buttons sidebar-menu-title">More...</span>
      </div>
    </a>

    <div v-show="isOpenMoreOptions" class="more-options-container">
      <a class="sidebar-link" v-on:click="handleLinkClick('members')" v-bind:class="{ active: activeDataCategory == 'members', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-users icon"></i>
          <span class="buttons sidebar-menu-title">Members</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('races')" v-bind:class="{ active: activeDataCategory == 'races', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-flag-usa icon"></i>
          <span class="buttons sidebar-menu-title">Races</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('events')" v-bind:class="{ active: activeDataCategory == 'events', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-calendar-day icon"></i>
          <span class="buttons sidebar-menu-title">Events</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('petitions')" v-bind:class="{ active: activeDataCategory == 'petitions', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-file-signature icon"></i>
          <span class="buttons sidebar-menu-title">Petitions</span>
        </div>
      </a>
      <a class="sidebar-link" v-on:click="handleLinkClick('blogs')" v-bind:class="{ active: activeDataCategory == 'blogs', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-edit icon"></i>
          <span class="buttons sidebar-menu-title">Blogs</span>
        </div>
      </a>
      <!-- ToDo: Remove code commented after update the section  -->
      <!-- <a class="sidebar-link" v-on:click="handleLinkClick('tv')" v-bind:class="{ active: activeDataCategory == 'tv', mobile: $root.isMobile }">
        <div class="social-sidebar-menu-item">
          <i class="fal fa-video icon"></i>
          <span class="buttons sidebar-menu-title">Crowdpac TV</span>
        </div>
      </a> -->
    </div>
  </nav>
</template>

<style scoped>
nav {
  background: var(--white);
}
div.social-sidebar-menu-item {
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.1em;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  height: 100%;
  padding: 8px;
}

a.sidebar-link {
  display: block;
  color: var(--black);
  font-weight: 600;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px 0;
  text-decoration: none;
}
a.sidebar-link.mobile .sidebar-menu-title {
  display: none;
}
a.sidebar-link:hover {
  color: var(--highlight);
  background-color: var(--primary-blue-100);
}
a.sidebar-link.active {
  color: var(--highlight);
  background-color: var(--primary-blue-100);
}
a.sidebar-link.active.mobile {
  background-color: var(--white);
  display: contents;
}
nav.tablet .social-sidebar-menu-item {
  padding: 5px 5px 5px 10px;
  margin-bottom: 7px;
}
nav.tablet span.sidebar-menu-title {
  font-size: 0.8em;
  padding-left: 8px;
}

nav.tablet .social-sidebar-menu-item svg {
  max-width: 25px;
}

span.sidebar-menu-title {
  padding-left: 4px;
  cursor: inherit;
  flex: 5;
}
nav.mobile div.social-sidebar-menu-item {
  padding: 0px;
  margin-bottom: 5px;
  justify-content: center;
}
.icon {
  font-size: 22px;
  flex: 1;
}
.more-options-container {
  padding-left: 20px;
}
@media screen and (max-width: 768px) {
  .more-options-container .icon {
    font-size: 18px;
  }
}
@media screen and (max-width: 450px) {
  .more-options-container .icon {
    font-size: 16px;
  }
}
</style>
